import React, {Component} from 'react';
import { render } from 'react-dom';
import RolebasedContent from '../function-components/RolebasedContent'
import RoleBasedContentDemo from '../function-components/RoleBasedContentDemo'

function Rolebased() {
    return (
      <>
          <RoleBasedContentDemo />
      </>
    )
  }

export default Rolebased;

